// What the chat screen and the ChatShell sidebar share: the Riwayat list
// follows every turn (bump), and a rename in the sidebar reaches the open
// conversation's title (renamed).
import { createContext, useContext } from "react";

export interface ChatShellApi {
  /** Bumped after every turn so Riwayat reloads. */
  historyTick: number;
  bumpHistory: () => void;
  /** The last conversation renamed from the sidebar. */
  renamed: { id: string; title: string } | null;
  setRenamed: (r: { id: string; title: string }) => void;
  /** Opens Bantuan (the profile menu item; the guest bar too). */
  openHelp: () => void;
}

export const ChatShellContext = createContext<ChatShellApi | null>(null);

export function useChatShell(): ChatShellApi | null {
  return useContext(ChatShellContext);
}
